import React, {FC, ReactElement, useEffect, useRef} from 'react';
import './Video.scss';
import styled from 'styled-components';

type videoProps = {
    src: string,
    type:string,
    isShadow: boolean,
    shape: string,
    round: string,
    width: string,
    verticalAlignment: string,
    horizontalAlignment: string,
    code:any,
    controls:boolean,
    loop:boolean,
    autoplay:boolean,
    anchorName:string,
    anchorTrigger:string
}

type videoWrapperProps = {
    verticalAlignment: string,
    horizontalAlignment: string,
}

type videoLayoutProps = {
    width: string,
    round: string,
    shape: string,
    isShadow: boolean,
    elementWidth:string|null
}

type videoElementProps = {
    round: string,
}

const VideoWrapper = styled.div<videoWrapperProps>`
&.videoWrapper {
  align-items: ${props => props.verticalAlignment || 'inherit'};
  justify-content: ${props => props.horizontalAlignment || 'inherit'};
  @media (max-width:768px) {
    align-items: center;
    justify-content: center;
  }
}
`;

const VideoLayout = styled.div<videoLayoutProps>`
&.videoLayout {
     border-radius: ${props => props.round ? props.round : '0'};
     height: auto;
     width: ${props => props.width + '%' || '100%'};
     max-width:100%;
      @media (max-width: 768px) {
        width:100%;
      }
    box-shadow: ${props => props.isShadow ? 'rgba(0, 0, 0, 0.15) 0px 4px 8px' : 'none'};
    ${  props => props.shape === 'circle'
        &&`
        border-radius: 100% !important;
        width: ${props.width + '%' || '100%'}; 
        padding-top: ${props.width + '%' || '100%'};
        video,
        .noVideo {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            overflow: hidden;
        }`   
    };
    ${  props => (props.shape === 'square') &&`
        border-radius: 0 !important;
        width: ${props.width + '%' || '100%'}; 
        padding-top: ${props.width + '%' || '100%'};
        video,
        .noVideo {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            overflow: hidden;
        }`
    };
     ${props => (props.shape === '16-9') &&`
         width: ${props.width + '%' || '100%'}; 
         height: ${Number(props.elementWidth) ? (Math.round(56.25*Number(props.elementWidth)/100)) + 'px' : 'auto'};
    `};
    @media (max-width:768px) {
        width:100%;
        ${props => (props.width && Number(props.width) < 50) && `
            width:50%;
            ${(props.shape === 'circle' || props.shape === 'square') && `padding-top: 50%;`};
            ${props.shape === '16-9' &&`
                height: ${Number(props.elementWidth) ? (Math.round(56.25*Number(props.elementWidth)/100)) + 'px' : '50%'};
            `};`
        };
    }
     .iframeWrapper {
       &::before {    
        filter: ${props => props.round ? props.shape === 'square' ? 'blur(0)' : 'blur('+props.round+')' : 'none'};
       }
       iframe {
       border-radius: ${props => props.round ? props.round : '0'};
        clipPath: ${props => props.round ? 'inset(0% 0% 0% 0% round '+props.round+')' : 'none'};
       }
     }
}
`;

const VideoElement = styled.video<videoElementProps>`
&.libraryVideo {
  border-radius: ${props => props.round ? props.round : '0'};
  ${props => (props.round === '100%' || props.round === '100px') &&`
      border-radius: 100%;
      height:100%;
  `};
}
`;




const Video: FC<videoProps> = ({...props}): ReactElement => {

    const elementRef = useRef<any>(null);
    let elementWidth:string|null = elementRef.current?.clientWidth;

    function isShowPlaceHolder() {
        return (
            props.type === 'Library' && !props.src
            || props.type === 'Youtube' && !props.src
            || props.type === 'Code' && !props.code
        )
    }


    return (
        <VideoWrapper className={'videoWrapper'} verticalAlignment={props.verticalAlignment} horizontalAlignment={props.horizontalAlignment}>
            <VideoLayout className={'videoLayout '  + (isShowPlaceHolder() ? 'noVideo' : '')} round={props.round} width={props.width} isShadow={props.isShadow} shape={props.shape} elementWidth={elementWidth}>
                {props.type === 'Library' && props.src.length > 24 && <VideoElement ref={elementRef} className={'libraryVideo'} key={props.src || props.autoplay.toString() || props.controls.toString() || props.loop.toString() || props.shape.toString()} autoPlay={props.autoplay} loop={props.loop} muted round={props.round} controls={props.controls}>
                    <source src={props.src} type="video/mp4"/>
                </VideoElement>}
                {props.type === 'Youtube' && props.src.length > 24 && <div className={'iframeWrapper'} key={props.src}>
                    <iframe ref={elementRef} src={props.src + (props.controls ? '':'?controls=0')} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>}
                {props.type === 'Code' && props.code && props.code.length && <div className={'iframeWrapper'} key={props.code}>
                    <div ref={elementRef} className="embeddedCode" dangerouslySetInnerHTML={{__html: props.code}}></div>
                </div>}
                {isShowPlaceHolder() && <div className={'noVideo'}><img src={environmentLink + '/assets/images/videpPlcaeHolder.svg'} alt="No video"/></div>}
            </VideoLayout>
        </VideoWrapper>
    );

};


export let settings:any;
let SettingsData;
const environmentLink:any = getEnvironmentLink();
try {
    SettingsData = require('../../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
        ],
        [//group
            {
                settingName: 'AddVideo',
                isMainSettings: true,
                title: 'Video',
            },
        ],
        [//group
            {
                settingName: 'Size',
                controls: [
                    {
                        controlName: 'Slider',
                        title: 'Size',
                        property: 'width',
                        defaultValue: 70,
                        suffix: '%',
                        min: 10
                    },
                ],
            },
            {
                settingName: 'Shape',
            },
            {
                settingName: 'BorderRadius',
            },
            {
                settingName: 'Shadow'
            },
        ],
        [
            {
                settingName: 'VideoSettings'
            },
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
}

function getEnvironmentLink() {
    if(process.env.PUBLIC_URL.length) return process.env.PUBLIC_URL;
    if(process.env.REACT_APP_ENV === 'staging') return "https://editor-bundle-staging.storydoc.com"; //staging link
    if(process.env.REACT_APP_ENV === 'production') return "https://editor-bundle.storydoc.com"; //production link
    if(process.env.REACT_APP_ENV === 'dev') return "http://localhost:3000"; //production link
}

//element options
const options = [
    { 
        name:'src',
        title: 'Change',
        icon: environmentLink + '/assets/images/change-video.svg',
        action: 'updateVideo',
        settingTitle: 'Video'
    },
    {
        name:'size',
        title: 'Size',
        icon: environmentLink + '/assets/images/Options/size.svg',
        action: 'setActiveWidth',
        settingTitle: 'Size'
    }
]

export default {
    Video,
    settings,
    options,
    label: 'Video'
};





